import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { Router, ActivatedRoute} from '@angular/router'
import {CampagneAndOfferFctService } from 'src/app/service/campagne-and-offer-fct.service';
import { MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { ShareCampagneOnContactUserComponent } from 'src/app/dialog/share-campagne-on-contact-user/share-campagne-on-contact-user.component';
import { ShowOfferDetailsComponent } from 'src/app/dialog/show-offer-details/show-offer-details.component';
import {data} from 'src/app/model/apx-chartCampagneDashboard.model'

@Component({
  selector: 'app-dashboard-youtube',
  templateUrl: './dashboard-youtube.component.html',
  styleUrls: ['./dashboard-youtube.component.css', '../../../assets/styles/table.css', '../../../assets/styles/panel.css','../../../assets/styles/text-title.css','../../../assets/styles/button.css','../../../assets/styles/body.css', '../../../assets/styles/dashboard.css']
})
export class DashboardYoutubeComponent implements OnInit {
  dashboardData: any = null;
  show = false
  chartOptions: any;
  selectedTabIndexContent = 0;
  videoSeleted = false
  showOffer = true
  overviewImpSeleted = true
  overviewReachSeleted = false
  overviewEngagementSeleted = false

  showVideoImp = true
  showVideoReach = false
  showVideoEngagement = false
  videoImpSeleted = true
  videoReachSeleted = false
  videoEngagementSeleted = false
  srcVideoImg = ""
  srcVideoCaption = ""
  expendedOverViewPosts = false
  expendedPosts = false
  videoSelected : any
  videochartDetailled : any

  excelOverviewUrl : any = ""
  excelUrl : any = ""
  pptxUrl : any = ""
  pigeReady = false
  constructor(
    private apiService : ApiService,
    private route: ActivatedRoute, 
    public fctBasic: CampagneAndOfferFctService,
    public dialog: MatDialog,
    private cdRef:ChangeDetectorRef,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.apiService.getDashboardCampagne(this.route.snapshot.params.id).subscribe(dashboardData => { 
      this.dashboardData = dashboardData
      this.show = true
      this.chartOptions = data
      this.showOffer = true
      this.cdRef.detectChanges();
      if (dashboardData.contenuCampaign.length > 0){
        this.srcVideoImg = this.dashboardData.contenuCampaign[0].picture
        this.srcVideoCaption = this.dashboardData.contenuCampaign[0].caption
        this.cdRef.detectChanges();
      }
      let str = this.dashboardData.campagne.campaignName.replace(/[-–. #"“”’/'+?^${}()|[\]\\]/g, " ")
      this.apiService.exportFileYoutube(str, dashboardData.campagne._id, dashboardData.campagne.startDate, dashboardData.campagne.endDate).subscribe(exportFile => { 
        this.excelOverviewUrl =  "/api/export/overview/" + exportFile.urlOverview
        this.excelUrl =  "/api/export/excel/" + exportFile.urlExcel
        this.pptxUrl =  "/api/export/pptx/" + exportFile.urlPptx
        this.pigeReady = true
        this.cdRef.detectChanges();
      })
    })
    
  }

  showOverviewChart(elem : any){
    switch (elem) {
      case "reach":
        this.overviewImpSeleted =false
        this.overviewReachSeleted = true
        this.overviewEngagementSeleted = false
        this.cdRef.detectChanges();
        break;
      case "impression":
        this.overviewImpSeleted = true
        this.overviewReachSeleted = false
        this.overviewEngagementSeleted = false
        this.cdRef.detectChanges();
        break;
        case "engagement":
          this.overviewImpSeleted = false
          this.overviewReachSeleted = false
          this.overviewEngagementSeleted = true
          this.cdRef.detectChanges();
      break;
      default:
        break;
    }
  }

  showPic(elem : any) {
    this.srcVideoImg = elem.picture
    this.srcVideoCaption = elem.caption
    this.cdRef.detectChanges();
    
  }

  showProfileInf(){
    try {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/detail-influencer/${this.dashboardData.Offer.influencerObjects.userId}`])
      );
      window.open(url, '_blank');
    } catch (error) {
      
    }  
  }

  setPostValue(elem : any){
    this.videoSelected = {}
    this.videoSelected.totalStatistics = {}
    this.videoSelected.totalStatistics.totalComment = elem.totalStatistics.totalComment
    this.videoSelected.totalStatistics.totalEngagement = elem.totalStatistics.totalEngagement
    this.videoSelected.totalStatistics.totalLike = elem.totalStatistics.totalLike
    this.videoSelected.totalStatistics.totalView = elem.totalStatistics.totalView
    this.videoSelected.totalStatistics.totalReach = elem.totalStatistics.totalReach
    this.videoSelected.totalStatistics.totalEstimatedMinutesWatched = elem.totalStatistics.totalEstimatedMinutesWatched
    this.videoSelected.totalStatistics.totalAverageViewDuration = elem.totalStatistics.totalAverageViewDuration
    this.videoSelected.chartPost = elem.chartPost
    this.srcVideoCaption = elem.youtubeInfoVideo.caption
    this.srcVideoImg = elem.youtubeInfoVideo.picture
    if (elem.chartPost.labelData.length == 1){
      this.videochartDetailled = {
        type: "bar",
        stacked: false,
        height: 350,
        toolbar: {
        show: false,
        }
      }
    }else {
      this.videochartDetailled = {
        type: "area",
        stacked: false,
        height: 350,
        toolbar: {
        show: false,
        }
      }
    }
    this.cdRef.detectChanges();
  }

}
